import React, {} from 'react';
import CountdownTimer from '../Components/CountdownTimer';
import Button from './Button';


const InfoBody = () => {
    let drawTime = { date: '', date2: '', time: '', time2: '' }
    const nowDate = new Date();
    const draw1 = new Date('2024-06-05T18:00:00');
    const draw2 = new Date('2024-07-05T18:00:00');
    const draw3 = new Date('2024-08-05T18:00:00');
    const draw4 = new Date('2024-09-05T18:00:00');
    const draw5 = new Date('2024-10-05T18:00:00');
    const draw6 = new Date('2024-11-05T18:00:00');
    const draw7 = new Date('2024-12-05T18:00:00');
    const draw8 = new Date('2025-01-05T18:00:00');

    if (nowDate < draw2) {
        drawTime = { date: '2024-07-05', date2: '2024.07.05', time: '18:00', time2: '18:00:00' }
    } else if (nowDate < draw3) {
        drawTime = { date: '2024-08-05', date2: '2024.08.05', time: '18:00', time2: '18:00:00' }
    } else if (nowDate < draw4) {
        drawTime = { date: '2024-09-05', date2: '2024.09.05', time: '18:00', time2: '18:00:00' }
    } else if (nowDate < draw5) {
        drawTime = { date: '2024-10-05', date2: '2024.10.05', time: '18:00', time2: '18:00:00' }
    } else if (nowDate < draw6) {
        drawTime = { date: '2024-11-05', date2: '2024.11.05', time: '18:00', time2: '18:00:00' }
    } else if (nowDate < draw7) {
        drawTime = { date: '2024-12-05', date2: '2024.12.05', time: '18:00', time2: '18:00:00' }
    } else if(nowDate < draw8){
        drawTime = { date: '2025-01-05', date2: '2024.01.05', time: '18:00', time2: '18:00:00' }
    }else{
        drawTime = { date: '2025-01-05', date2: '2025.01.05', time: '18:00', time2: '18:00:00' }
    }


    return (
        <div className='h-fit w-full bg-slate-200 px-40 mobile:px-0 laptop:px-20'>
            <div className='w-full h-full bg-white'>
                <img className='w-full object-cover mobile:h-40' src="./images/info_banner_3.png" alt="banner_thin" />
                <div className='w-full h-full px-36 py-10 text-start space-y-8 mobile:px-4 mobile:text-justify tablet:px-16'>
                    <p>БРИТТО картаараа гүйлгээ хийх тутамдаа тохирлын эрх авч 20,000₮ - 1,000,000₮ -н урамшууллын эзэн болоорой.</p>

                    <div>
                        <p className='font-bold text-[#0987F3]'>УРАМШУУЛЛЫН ХУГАЦАА</p>
                        <p>2024 оны 06-р сарын 01-ны өдрөөс 12-р сарын 31-нийг дуустал үргэлжилнэ.</p>
                    </div>

                    <div>
                        <p className='font-bold text-[#0987F3]'>УРАМШУУЛЛЫН ХОНЖВОР</p>
                        <p>Таны цуглуулсан урамшууллын дугаараас</p>
                        <ul className='list-disc ml-5'>
                            <li>3 орон таарвал - <span className='font-medium'>20,000₮</span></li>
                            <li>4 орон таарвал - <span className='font-medium'>50,000₮</span></li>
                            <li>5 орон таарвал - <span className='font-medium'>100,000₮</span></li>
                            <li>6 орон таарвал - <span className='font-medium'>300,000₮</span></li>
                            <li>7 орон таарвал - <span className='font-medium'>1,000,000₮</span> урамшууллын эзэн болох боломжтой.</li>
                        </ul>
                    </div>

                    <p>САР БҮР <span className='font-bold text-[#0987F3]'>1000 ГАРУЙ</span> ХАРИЛЦАГЧ ТОДОРНО</p>

                    <div>
                        <p className='font-bold text-[#0987F3] uppercase'>Урамшууллын эрх хэрхэн цуглуулах вэ?</p>
                        <p>Харилцагч та Бритто картаа</p>
                        <ul className='list-disc ml-5'>
                            <li>TDB POS дээр уншуулах бүрт 1 эрх</li>
                            <li>Бүх төрлийн E-Commerce буюу Онлайн худалдан авалт хийх бүрт 1 эрх</li>
                            <li>Гадаадад дурын POS дээр уншуулах бүрт 1 эрх</li>
                            <li>Visa иргэн хоорондын шилжүүлгийн үйлчилгээ хийх бүрт 1 эрх</li>
                            <li>Шинээр Бритто карт захиалахад 10 эрх</li>
                            <li>TDB Online-даа Бритто картаа холбоод QPAY-р гүйлгээ хийх бүрдээ урамшууллын 1 эрх авч сар бүрийн азтай 1000 гаруй харилцагчийн нэг болоорой.</li>
                        </ul>
                    </div>

                    <div>
                        <p className='font-bold text-[#0987F3] uppercase'>Урамшууллын эздийг тодруулах өдрүүд</p>
                        <table className='min-w-fit divide-x divide-y border border-solid border-gray-200'>
                            <thead className='px-8 mobile:px-2'>
                                <tr className='bg-[#0987F3] p-8 text-white mobile:p-2'>
                                    <th className='border border-solid border-blue-300 px-4 py-1 mobile:px-1'>Хамрах урамшууллын эрхийн хугацаа</th>
                                    <th className='border border-solid border-blue-300 px-4 py-1 mobile:px-1'>Тохирол болох өдөр</th>
                                    <th className='border border-solid border-blue-300 px-4 py-1 mobile:px-1'>Тохирол болох суваг</th>
                                </tr>
                            </thead>
                            <tbody className='text-center'>
                                <tr>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>2024.06.01 - 2024.06.30</td>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>2024.07.05</td>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1' rowSpan={7}><a className='text-[#0987F3] underline' href="https://www.facebook.com/happypaymongolia">HAPPY PAY</a> болон <a className='text-[#0987F3] underline' href="https://www.facebook.com/tdbm.mn">TDB</a>-н Facebook хуудсаар 18:00 цагт тохирлыг шууд дамжуулна.</td>
                                </tr>
                                <tr>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>2024.07.01 - 2024.07.31</td>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>2024.08.05</td>
                                </tr>
                                <tr>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>2024.08.01 - 2024.08.31</td>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>2024.09.05</td>
                                </tr>
                                <tr>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>2024.09.01 - 2024.09.30</td>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>2024.10.05</td>
                                </tr>
                                <tr>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>2024.10.01 - 2024.10.31</td>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>2024.11.05</td>
                                </tr>
                                <tr>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>2024.11.01 - 2024.11.30</td>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>2024.12.05</td>
                                </tr>
                                <tr>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>2024.12.01 - 2024.12.31</td>
                                    <td className='border border-solid border-gray-300 px-4 py-1 mobile:px-1'>2025.01.05</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <p className='font-bold text-[#0987F3]'>Санамж</p>
                        <ul className='list-disc ml-5'>
                            <li>Мөрийтэй тоглоомын зориулалттай гүйлгээнд эрх олгогдохгүй болно</li>
                            <li>Сар бүр цуглуулсан урамшууллын эрхээрээ зөвхөн тухайн сарын урамшуулалд оролцох эрхтэй.</li>
                            <li>Тухайн сарын урамшууллын эрхийн дугаар нь тохирол болох өдрөөс 2 хоногийн өмнө үүсэх ба миний урамшууллын эрх хэсгээс харна уу.</li>
                            <li>Хэрэв та 6,7 дугаар сарын урамшууллын эзэн болсон бол 2024.08.31-ний дотор баталгаажуулалт хийнэ үү.</li>
                            <li>Хэрэв та 8 дугаар сарын урамшууллын эзэн болсон бол 2024.09.30-ны дотор баталгаажуулалт хийнэ үү.</li>
                            <li>Хэрэв та 9 дүгээр сарын урамшууллын эзэн болсон бол 2024.11.30-ны дотор баталгаажуулалт хийнэ үү.</li>
                            <li>Хэрэв та 10 дугаар сарын урамшууллын эзэн болсон бол 2024.12.31-ний дотор баталгаажуулалт хийнэ үү.</li>
                            <li>Хэрэв та 11 дүгээр сарын урамшууллын эзэн болсон бол 2025.01.31-ний дотор баталгаажуулалт хийнэ үү.</li>
                            <li>Хэрэв та 12 дугаар сарын урамшууллын эзэн болсон бол 2025.02.28-ны дотор баталгаажуулалт хийнэ үү.</li>
                            <li>Тус хугацаанд баталгаажуулалт хийхгүй бол таны дансанд урамшуулал шилжих боломжгүй болохыг анхаарна уу.</li>
                        </ul>
                    </div>
                    <div className='flex justify-center items-center'>
                        <Button style="bg-[#0168D7] text-white text-center text-sm font-semibold rounded-md w-fit px-8 h-10 shadow-lg hover:opacity-90 duration-150" name='Урамшууллын эрхээ шалгах' link="https://www.cardcentre.mn/eregister/index.php?appid=happy_pay" />
                    </div>
                    <div className='bg-blue-100 py-10 px-60 tablet:px-2 laptop:px-20 mobile:px-2'>
                        <CountdownTimer targetDate={drawTime.date !== '' ? (drawTime.date + " " + drawTime.time2) : ""} time={drawTime.date !== '' ? (drawTime.date2 + "-ны өдөр " + drawTime.time) : ""} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InfoBody;